import { useTranslation } from 'react-i18next';
import { type FallbackProps } from 'react-error-boundary';

export function PageErrorFallback({ resetErrorBoundary }: FallbackProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] gap-4 text-center px-4">
      <p className="text-danger font-semibold">{t('errors.pageBroken')}</p>
      <button
        type="button"
        onClick={resetErrorBoundary}
        className="px-4 py-2 bg-copper text-bone-soft rounded text-sm font-semibold hover:bg-copper-warm transition-colors"
      >
        {t('common.processing') === 'Processing...' ? 'Reload' : 'Muat Ulang'}
      </button>
    </div>
  );
}
